// @ts-nocheck
import { useCallback, useState } from 'react';
import globalHeaders from 'utils/globalHeaders';
import axios from 'config/api';
import beautifyUrl from 'utils/beautifyUrl';

function useDelete(path, config = {}) {
  const {
    headers = {},
    transformSave,
    transformFail,
    params = {},
    query = {},
    onFailure,
  } = config;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const deleteFn = useCallback(
    async (values, onSuccess, newConfig = {}) => {
      setLoading(true);
      const currentConfig = {
        ...config,
        ...newConfig,
      };

      try {
        let response = await axios.delete(beautifyUrl(path, currentConfig), {
          data: values,
          headers: { ...globalHeaders(), ...headers },
          // ...axiosConfig
        });

        if (transformSave) {
          response = transformSave(response);
        } else {
          response = response.data;
        }

        setData(response);
        setLoading(false);

        if (onSuccess) {
          onSuccess(response);
        }
        if (config?.onSuccess) {
          config.onSuccess(response);
        }
      } catch (err) {
        let e = err.response;
        let status = 500;

        if (e) {
          status = e.status;

          if (transformFail) {
            e = transformFail(e);
          } else {
            e = e?.data?.error || e?.data?.message || 'Server Error';
          }
        } else {
          e = 'Server Error';
        }

        setError(e);
        setLoading(false);

        if (onFailure) {
          onFailure(e, status);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(params), JSON.stringify(query)],
  );

  return [deleteFn, { data, loading, error }];
}

export default useDelete;
